import React from 'react';
import Layout from '../components/shared/Layout';
import Header from '../components/shared/Header';
import ProjectsDetail from '../components/projects/ProjectsDetail';
import Donate from '../components/shared/Donate';


const Projects = () => (
    <Layout title="Our Projects">
        <Header title="Our Projects" page="Projects" />
        <ProjectsDetail />
        <Donate />
    </Layout>
)

export default Projects;